import { useEffect, useState } from "react";
import { LoginRegistersService } from "../../../../_services/loginregisters.service";
import { Tabla } from "../../../../components/Table/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import DownloadExcel from "./DownloadExcel";
import {
  EyeOutlined,
} from "@ant-design/icons";
import ListRegUser from "./ListRegUser";
import RegistrosLogFilters from "./RegistrosLogFilters";

const ListRegistersLogin = () => {

  const rolesDictiornary = {
    "admin": "Administrador",
    "user": "Usuario",
    "guest": "Invitado"
  };

  const [dataLog, setDataLog] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [userData, setUserData] = useState({});
  const [showFilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState();

  useEffect(() => {
    const getData = async () => {
      const queryParams = buildQueryParams();
      let res = await LoginRegistersService.getAllRegisters(queryParams);
      const dataDecorator = formatData(res);
      setDataLog(dataDecorator);
    };
    getData();
  }, [filters]);

  const buildQueryParams = () => {
    const params = new URLSearchParams();
    for(const key in filters){
      params.append(key, filters[key]);
    }
    return params.toString();
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };
  const columns = [
    {
      title: "DNI",
      dataIndex: "dni",
    },
    {
      title: "Nombre y Apellido",
      dataIndex: "nomApe",
    },
    {
      title: "Tipo de Usuario",
      dataIndex: "tipoUsuario",
    },
    {
      title: "Código Externo",
      dataIndex: "codigoExterno",
    },
    {
      title: "Rol",
      dataIndex: "rol",
    },
    {
      title: "Cantidad De Login",
      dataIndex: "cantidadLogin",
    },
    {
      title: "Último Ingreso",
      dataIndex: "lastLog",
    },
    {
      title: "Acciones",
      dataIndex: "acciones",
      render: (text, row) => {
        return <div className="d-flex justify-content-around">
          <Button
            className="d-flex align-items-center ml-2"
            variant="contained"
            // style={{
            //   color: `${(verAbogado.show && row.nrodni === verAbogado.key) ? "#1890ff" : "#000000d9"}`,
            //   borderColor: `${(verAbogado.show && row.nrodni === verAbogado.key) ? "#1890ff" : "#d9d9d9"}`
            // }}
            onClick={() => handleShow(row)}
          >
            <EyeOutlined
              // style={{
              //   color: `${(verAbogado.show && row.nrodni === verAbogado.key) ? "#1890ff" : "#000000d9"}`,
              // }}
            />
          </Button>
        </div>;
      }
    },
  ];

  const formatData = (arrayData = []) => {
    try {
      return arrayData.map((item) => {
        return {
          dni: item.usuario_dni,
          nomApe: `${item.usuario.apellido}, ${item.usuario.nombre}`.toUpperCase(),
          tipoUsuario: item.abogado ? "Abogado" : "Usuario",
          codigoExterno: item.abogado ? item.abogado.codexterno : "-",
          rol: rolesDictiornary[item.usuario.rol],
          cantidadLogin: item.cant_login,
          lastLog: item.date_last_log,
        };
      });
    }
    catch (err) {
      console.log(err);
      return [];
    }
  };

  const handleShow = (row) => {
    setUserData(row);
    setShowModal(true);
  };

  return (
    <div className="container mt-5">
      <div className="button-filter">
        {showFilter ? (
          <Button
            variant="danger"
            onClick={() => setShowFilter(false)}
            className="danger-button d-flex align-items-center"
            style={{ maxWidth: 105 }}
          >
            <FontAwesomeIcon icon={faArrowDown} size="1x" /><span className="ml-2">Ocultar</span>
          </Button>
        )
          : (
            <Button
              onClick={() => setShowFilter(true)}
              className="custom-button d-flex align-items-center"
              style={{ maxWidth: 105 }}
            ><FontAwesomeIcon icon={faArrowUp} size="1x" /><span className="ml-2">Mostrar</span>
            </Button>
          )}
      </div>
      <RegistrosLogFilters 
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        style={{ marginBottom: "30px" }}
        onFilterChange={handleFilterChange}
      />
      <div>
        <h3 className="text-center mb-4">Tabla Login</h3>
        <DownloadExcel data={dataLog} columns={columns} nameFile={`registros_logs_general${new Date().getTime()}.xlsx`}/>
      </div>
      {formatData ? <Tabla dataList={dataLog} columns={columns} /> : null}
      {showModal ? <ListRegUser userData={userData} setShowModal={setShowModal}/> : null}
    </div>
  );
};

export default ListRegistersLogin;